import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Shield, Award, GraduationCap, CheckCircle, ArrowRight } from 'lucide-react';
import SEO from '../components/SEO';
import { FadeIn, PageHero } from '../components/PageComponents';
import { certificeringData } from '../data/geoData';

const icons = { Shield, Award, GraduationCap, CheckCircle };

const CertificeringPage = () => (
  <main className="pt-28 min-h-screen">
    <SEO title="Keurmerk & Certificering - Staffing Force" description="Staffing Force is NEN 4400-1 gecertificeerd, B Corp gecertificeerd en ECABO erkend leerbedrijf. Kwaliteit en betrouwbaarheid gegarandeerd." keywords="NEN certificering, B Corp, ECABO, keurmerk, staffing force, detachering" />
    <PageHero label="Kwaliteit & Betrouwbaarheid" title={certificeringData.title} description={certificeringData.intro} image="https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=1920&q=85&auto=format&fit=crop" />
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-8">
          {certificeringData.certs.map((c, i) => {
            const Icon = icons[c.icon] || CheckCircle;
            return (
              <FadeIn key={i} delay={i * 0.1}>
                <div className="bg-gray-50 rounded-xl p-8 border border-gray-100 h-full">
                  <Icon size={32} className="text-[#00897B] mb-4" />
                  <h2 className="text-xl font-bold text-gray-900 mb-3">{c.name}</h2>
                  <p className="text-gray-600 text-sm leading-relaxed">{c.desc}</p>
                </div>
              </FadeIn>
            );
          })}
        </div>
      </div>
    </section>
    <section className="py-20 bg-[#0d1b2a]">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <FadeIn>
          <h2 className="text-3xl font-bold text-white mb-6">Meer weten over onze kwaliteitsstandaarden?</h2>
          <Link to="/contact" className="bg-[#00897B] hover:bg-[#00796B] text-white px-8 py-3 rounded font-semibold text-sm transition-all hover:-translate-y-0.5 inline-flex items-center gap-2">Neem contact op <ArrowRight size={16} /></Link>
        </FadeIn>
      </div>
    </section>
  </main>
);

export default CertificeringPage;
